// the batch mutation silently drops emails that are no longer active in Memberful
// (e.g. already migrated, so their subscription was deleted there) — surface them
export const formatBatchMessage = (selectedEmails, results) => {
  const success = results.filter(r => r.status === 'success').length;
  const failed = results.filter(r => r.status === 'failed').length;
  let message = `Batch complete: ${success} success, ${failed} failed out of ${results.length} total`;

  const returnedEmails = new Set(results.map(r => r.memberfulEmail.toLowerCase()));
  const notFound = selectedEmails.filter(e => !returnedEmails.has(e.toLowerCase()));
  if (notFound.length > 0) {
    message += `. ${notFound.length} selected member(s) not found as active in Memberful (probably already migrated): ${notFound.join(', ')}`;
  }

  return message;
};

// must mirror isSubscriptionFreeTrial in api/integrations/memberful/helpers.js,
// otherwise a member shown as paying could still be skipped as a trial on migration
export const isFreeTrial = ({ trialEndAt, expiresAt }) => !!trialEndAt && trialEndAt === expiresAt;

// 'paying' = at least one active non-trial subscription (to the filtered plan, if any),
// i.e. something will actually migrate; 'free' is everyone else
export const filterMembersByPaymentStatus = (members, paymentStatus, planFilter) => {
  if (paymentStatus === 'all') return members;
  return members.filter(member => {
    const isPaying = member.subscriptions.some(s =>
      s.active && !isFreeTrial(s) && (!planFilter || String(s.plan.id) === planFilter)
    );
    return paymentStatus === 'paying' ? isPaying : !isPaying;
  });
};
